import bpla from './bpla'
import bpak from './bpak'
import education from './education'

export default {
  bpla,
  bpak,
  education,
}
